import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useStore, useToast } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { APIS, SF_ORG_USR_LIST, SG_ORG_USR_LIST } from "./services/OsciAprvService";
import { comnUtils } from "@/comn/utils";

/*
 * Organization User List Popup
 * !== 기관 사용자 목록 팝업 ==!
 * TODO KNH 공통 팝업으로 사용할지 확인 필요
 */
export const OSCI0108006Q = (props: any): JSX.Element => {
    const { callbackFn, aprvId } = props;

    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const [orgUsrLstData, setOrgUsrLstData] = useState(comnUtils.getGridData([]));

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Serach Approvers List Form !== 결재자 검색 폼 ==!
        usrList: useForm({
            defaultSchema: SF_ORG_USR_LIST,
            defaultValues: { aprvId: aprvId },
        }),
    };
    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Approval Path Management List !== 결재선 검색 결과 결재자 목록 ==!
        usrList: useGrid({
            defaultSchema: SG_ORG_USR_LIST,
        }),
    };
    const render = {
        orgUsrLst: {
            head: {},
            cell: {
                usrIdntfNo: (props: any) => {
                    const { rowValues, value } = props;
                    return (
                        <span
                            className={"underline cursor-pointer text-uf-blue"}
                            onClick={() => {
                                handler.onClickUsrIdntfNo(rowValues);
                            }}
                        >
                            {rowValues.usrIdntfNo}
                        </span>
                    );
                },
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Check Approval Path Management List !== 결재선 관리 목록 조회==!
        getOrgUsrList: useFetch({
            api: (page = grid.usrList.page) => APIS.getOrgUsrList(form.usrList.getValues(), page, grid.usrList.size),
            enabled: comnUtils.isEmpty(form.usrList.errors),
            key: [grid.usrList.page, grid.usrList.size],
            onSuccess: (rtnData) => {
                console.log("getOrgUsrList", rtnData);
                setOrgUsrLstData(rtnData?.orgUsrList);
            },
            onError: (error) => {
                let errorMessage = error.message;
                if (error.response?.data?.errorMessage) {
                    errorMessage = error.response.data.errorMessage;
                }
                modal.openModal({ content: errorMessage });
                // toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getOrgUsrList: (page = 0) => {
            form.usrList.handleSubmit(
                (data) => {
                    grid.usrList.setPage(page);
                    fetch.getOrgUsrList.fetch(page);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        onClickUsrIdntfNo: (rowValues: any) => {
            if (callbackFn) {
                callbackFn(rowValues);
            }
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getOrgUsrList.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Title title={t("T_USR_LIST")} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.usrList.schema.deptNm}></Group.Control>
                            <Group.Control {...form.usrList.schema.usrNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Layout.Button role={"reset"} onClick={() => form.usrList.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role={"search"}
                                onClick={() => {
                                    handler.getOrgUsrList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Grid {...grid.usrList.grid} render={render.orgUsrLst} data={orgUsrLstData} />
                </Group.Body>
            </Group>
        </Page>
    );
};
